import {Popup} from "../popup";
import './style.css';

class InfoBanner extends Popup {
	constructor(data) {
		super('infoBanner', true, true);
	}
}

export {InfoBanner}